import convertCSTToLocal from "./convertCSTToLocal";

function formatDateMontDayYearTime(dateString?: string): string {
	if (!dateString) {
		return "";
	}
	return convertCSTToLocal(dateString).format("MMM D, YYYY h:mm A");
}

export default formatDateMontDayYearTime;
